import React from "react";
import { FileCardOptionsTypeEnum } from "app/components/MediaUploader/types";
import type { TicketAttachmentFile } from "app/containers/Features/containers/Ticket/types";
import useUploadFilePresentation from "./hooks/useUploadFilePresentation";
import AttachmentCard from "./components/AttachmentCard";
interface Props {
  files?: TicketAttachmentFile[];
  uploadingCards?: { id: string; name: string }[];
  onAction?: (
    type: FileCardOptionsTypeEnum,
    file: TicketAttachmentFile,
  ) => void | Promise<void>;
  onPreview?: (file: TicketAttachmentFile) => void;
  renameAttachmentLoading?: boolean;
  renamingFileId?: string | null;
  renameValue?: string;
  onRenameValueChange?: (value: string) => void;
  onRenameSubmit?: () => void;
  onRenameCancel?: () => void;
}

const UploadFile: React.FC<Props> = ({
  files = [],
  uploadingCards = [],
  onAction,
  onPreview,
  renameAttachmentLoading = false,
  renamingFileId,
  renameValue = "",
  onRenameValueChange,
  onRenameSubmit,
  onRenameCancel,
}) => {
  const { renameInputRef, renderFileMedia, avatar, userName } =
    useUploadFilePresentation({ renamingFileId });

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
      {uploadingCards.map((uploadingCard) => (
        <AttachmentCard
          key={uploadingCard.id}
          variant="uploading"
          fileName={uploadingCard.name}
          avatar={avatar}
          userName={userName}
        />
      ))}
      {files.map((file) => (
        <AttachmentCard
          key={file.id}
          variant="uploaded"
          fileName={file.name}
          file={file}
          renameAttachmentLoading={renameAttachmentLoading}
          isRenaming={renamingFileId === file.id}
          renameValue={renameValue}
          onAction={onAction}
          onPreview={onPreview}
          onRenameValueChange={onRenameValueChange}
          onRenameSubmit={onRenameSubmit}
          onRenameCancel={onRenameCancel}
          renameInputRef={renameInputRef}
          renderFileMedia={renderFileMedia}
          avatar={avatar}
          userName={userName}
        />
      ))}
    </div>
  );
};

export default UploadFile;
